import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { SITE_TITLE, TITLE_DIVIDER } from 'config'
import { selectLocale } from 'store/locale/slice'
import { useEffect, useState } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

type Props = {
  titleId?: string
}

export default function HeadHelmet({ titleId }: Props) {
  const locale = useSelector(selectLocale)
  const intl = useIntl()
  const [title, setTitle] = useState<string>(SITE_TITLE)

  useEffect(() => {
    if (titleId) {
      setTitle(`${intl.formatMessage({ id: titleId })}${TITLE_DIVIDER}${SITE_TITLE}`)
    }
  }, [titleId])

  return (
    <HelmetProvider>
      <Helmet htmlAttributes={{ lang: locale.language.code }}>
        <title>{title}</title>
      </Helmet>
    </HelmetProvider>
  )
}
